export default class ArrayHandler {

	public static includes (array: any[], element: any) {
		return array.indexOf(element) !== -1;
	}

	public static remove (array: any[], element: any) {
		const index = array.indexOf(element);

		if (index === -1) {
			return;
		}

		array.splice(index, 1);
	}

	public static shuffle<T> (a: T[]) {
		for (let i = a.length; i; i--) {
			let j = Math.floor(Math.random() * i);
			[a[i - 1], a[j]] = [a[j], a[i - 1]];
		}

		return a;
	}

	public static shuffled<T> (a: T[]) {
		return this.shuffle(a.slice());
	}
}


// WEBPACK FOOTER //
// ./code/foundation/handlers/ArrayHandler.ts